import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import LocationService from "services/LocationService";

export const keyCountry = "9d2609d8-1f5d-45f9-aba2-c7346b715c6d";

export const getCountry = createAsyncThunk(
  "setting/getCountry",
  async (data, { rejectWithValue }) => {
    try {
      const response = await LocationService.getCountry();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getProvinceByCountry = createAsyncThunk(
  "setting/getProvinceByCountry",
  async (data, { rejectWithValue }) => {
    try {
      const response = await LocationService.provinceByCountry(keyCountry);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getWardByProvince = createAsyncThunk(
  "setting/getWardByProvince",
  async (id, { rejectWithValue }) => {
    try {
      const response = await LocationService.wardByProvince(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getAllWard = createAsyncThunk(
  "setting/getAllWard",
  async (data, { rejectWithValue }) => {
    try {
      const response = await LocationService.getAllWard(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  countryList: [],
  provinceList: [],
  wardList: [],
};

export const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setWardList: (state, action) => {
      state.wardList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.countryList = action.payload;
      })
      .addCase(getCountry.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getProvinceByCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProvinceByCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.provinceList = action.payload;
      })
      .addCase(getProvinceByCountry.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getWardByProvince.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWardByProvince.fulfilled, (state, action) => {
        state.loading = false;
        state.wardList = action.payload;
      })
      .addCase(getWardByProvince.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAllWard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllWard.fulfilled, (state, action) => {
        state.loading = false;
        state.wardList = action.payload;
      })
      .addCase(getAllWard.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setWardList } = locationSlice.actions;

export default locationSlice.reducer;